import Paper from "@mui/material/Paper";
import styled from "styled-components";

export const DashboardShell = styled.div`
  height: calc(100vh - (var(--navbar-height) + var(--footer-height)));
  width: 100%;
  display: grid;
  grid-template-columns: ${(p) => (p.$leftOpen ? "200px" : "0px")} minmax(0, 1fr)
    ${(p) => (p.$rightOpen ? "280px" : "0px")};
  background: #f4f7fe;
  overflow: hidden;
  transition: grid-template-columns 200ms ease;
`;

export const LeftPanel = styled.div`
  grid-column: 1;
  background: #fff;
  border-right: 1px solid #e9edf7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 10px 0px 30px rgba(0, 0, 0, 0.02);
`;

export const MainPanel = styled.div`
  grid-column: 2;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const MainHeader = styled.div`
  height: ${(p) => (p.$hidden ? "0px" : "44px")};
  padding: ${(p) => (p.$hidden ? "0" : "6px 16px")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: ${(p) => (p.$hidden ? "none" : "1px solid rgba(15, 23, 42, 0.06)")};
  overflow: hidden;
  transition: height 200ms ease;
`;

export const MainHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const MainHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MainScroll = styled.div`
  flex: 1;
  overflow: auto;
  background: #f4f7fe;
  padding: 12px 16px;
`;

export const ContentInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RightPanel = styled.div`
  grid-column: 3;
  background: #fff;
  border-left: 1px solid #e9edf7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: -10px 0px 30px rgba(0, 0, 0, 0.02);
`;

export const CardPaper = styled(Paper)`
  border-radius: 12px !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
`;

export const AgeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const AgeTheadTh = styled.th`
  text-align: ${(p) => p.$align || "left"};
  padding: 0 0 10px 0;
  font-size: 12px;
  color: #718096;
  font-weight: 700;
`;

export const AgeRow = styled.tr`
  border-bottom: 1px solid #f1f5f9;
`;

export const AgeCell = styled.td`
  padding: ${(p) => (p.$dense ? "10px 0" : "10px 15px")};
  font-size: 13px;
  font-weight: ${(p) => (p.$bold ? 700 : 500)};
  text-align: ${(p) => p.$align || "left"};
  white-space: nowrap;
`;

export const MfBarTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
`;

export const MfBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
  min-width: 0;
`;

export const MfBarTrack = styled.div`
  flex: 1;
  height: 22px;
  background: #eef2f7;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const MfSegment = styled.div`
  height: 22px;
  background: ${(p) => p.$bg || "#94a3b8"};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 800;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
`;

export const LegendList = styled.div`
  width: 180px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const LegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: ${(p) => p.$color || "#94a3b8"};
  flex: 0 0 auto;
`;
